import * as Services from "../../Service/Service";
import * as Url from "../../Service/Url";

export const GetClientDetailData = async (email) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_CLIENT_DETAIL_DATA + `EmailId=${email}`,
    token
  );
  return res;
};

export const GetListOfClientDetail = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_LIST_OF_CLIENT_DETAIL, token);
  return res;
};

export const CreateClient = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.CREATE_CLIENT, payload, token);
  return res;
};

export const AcceptTermCondition = async (clientId, AcceptTermCondition) => {
  const token = localStorage.getItem("token");
  let res = await Services.PUT(
    Url.ACCEPT_TERM_CONDITION +
      `clientId=${clientId}&isAcceptTermCondition=${AcceptTermCondition}`,
    "",
    token
  );
  return res;
};
